import { useNavigate } from 'react-router-dom';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { User } from '..//src/context/AuthContext';

interface HeaderProps {
  title: string;
  user: User | null;
  client?: { id: string; name: string; surname: string; client_number: string } | null;
  toggleSidebar: () => void;
  isSidebarVisible: boolean;
  showClientNumber?: boolean;
}

const Header = ({ title, user, client, toggleSidebar, isSidebarVisible, showClientNumber = false }: HeaderProps) => {
  return (
    <header className="bg-white shadow-md p-4 flex justify-between items-center">
      {/* Left Side: Title with optional client name, surname, and client_number */}
      <div className="flex items-center space-x-2">
        <button
          onClick={toggleSidebar}
          className="p-2 text-gray-700 hover:bg-gray-300 rounded-md"
          aria-label={isSidebarVisible ? 'Hide sidebar' : 'Show sidebar'}
        >
          <Bars3Icon className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-bold">
          {showClientNumber && client && (
            <>
              {client.name && <span className="text-gray-600">{client.name} </span>}
              {client.surname && <span className="text-gray-600">{client.surname} </span>}
              {client.client_number && <span className="text-gray-600">({client.client_number}) </span>}
            </>
          )}
          {title}
        </h1>
      </div>

      {/* Right Side: User Info */}
      <div className="flex items-center space-x-4">
        <span className="text-gray-600">
          Logged in as:{' '}
          {user ? (
            <>
              {(user.username || user.name) && <span>{user.username || user.name}</span>}
              {user.surname && <span className="ml-1">{user.surname}</span>}
              {!user.username && !user.name && !user.surname && (
                <span>{user.email}</span>
              )}
            </>
          ) : (
            'Unknown'
          )}
        </span>
        <button
          onClick={() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.dispatchEvent(new Event('auth-changed'));
            window.location.href = '/login';
          }}
          className="text-blue-600 hover:underline"
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;